import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=f797a646&scoped=true&"
import script from "./Classroom.vue?vue&type=script&lang=js&"
export * from "./Classroom.vue?vue&type=script&lang=js&"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=f797a646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f797a646",
  null
  
)

export default component.exports